import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { MobileControllerLegacy } from '../../controllers/mobile-controller-legacy';

/**
 * The SeSpacer component
 * @element se-spacer
 */
@customElement('se-spacer')
export class SeSpacer extends LitElement {
  private mobileControllerLegacy = new MobileControllerLegacy(this);

  @property({ type: String })
  desktop: string;

  @property({ type: String })
  mobile: string;

  render(): TemplateResult {
    const height = this.mobileControllerLegacy.isMobile
      ? `${this.mobile ? this.mobile : this.desktop}rem`
      : `${this.desktop}rem`;
    return html`<div class="se-spacer" style="height: ${height};"></div>`;
  }
}
